import type { FundingApplicationSchemas } from "@wayflyer/api-types";
import type { IntlShape } from "react-intl";
import * as Yup from "yup";

import { MESSAGES } from "./message-definitions";

export const makeAboutYourBusinessSchema = (intl: IntlShape) =>
  Yup.object().shape({
    whoYouSellTo: Yup.array()
      .min(1, intl.formatMessage(MESSAGES.formErrorPleaseSelect))
      .of(Yup.string<FundingApplicationSchemas.CustomerSegment>())
      .required(intl.formatMessage(MESSAGES.formErrorFieldRequired)),
    whereYouSell: Yup.array()
      .min(1, intl.formatMessage(MESSAGES.formErrorPleaseSelect))
      .of(Yup.string<FundingApplicationSchemas.SalesChannel>())
      .required(intl.formatMessage(MESSAGES.formErrorFieldRequired)),
    whatYouSell: Yup.array()
      .min(1, intl.formatMessage(MESSAGES.formErrorPleaseSelect))
      .of(Yup.string<FundingApplicationSchemas.ProductOffering>())
      .required(intl.formatMessage(MESSAGES.formErrorFieldRequired)),
  });
